@if (displayMode() === FieldInterventionContextLayersDisplayModeEnum.EDITABLE) {
    <app-select
        [canClear]="false"
        [defaultValue]="contextLayersSelected()"
        [isMultiSelect]="true"
        [label]="'contextLayers' | transloco"
        [options]="contextLayersOptions()"
        (optionSelected)="selectionChange.emit($event)" />
} @else if (contextLayersSelected().length) {
    <div class="flex flex-row items-center gap-2">
        <app-readonly-dropdown-list
            class="flex-1"
            [label]="'contextLayers' | transloco"
            [options]="contextLayersSelected()" />

        <fa-icon
            class="text-outline shrink-0"
            [icon]="['fas', 'circle-info']"
            [matTooltip]="'contextLayerEditing' | transloco" />
    </div>
} @else if (showEmptyReadonlyState()) {
    <p class="text-body-2 text-custom-dark-grey font-normal whitespace-pre-line">
        {{ 'noContextLayerSelected' | transloco }}
    </p>
}
